import React, { useEffect, useState } from 'react'
import { connect } from "react-redux";
import * as d from "../../../reducers/domainReducer";
import { firstNameFirst, getFirstName } from "../../../helpers/formatting";
import { Icon, Typography, Divider, LinkList, Backdrop, LinkText } from "../../ecosystem";
import * as types from "../../../constants/actionTypes";
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";
import { Link as RouterLink, Redirect } from "react-router-dom";
import { withRouter } from "react-router-dom";
import usePickerFor from './hooks/usePickerFor';
import Spinner from "../spinner";
import SelectPatient from "./SelectPatient";
import SectionLoadingError from "../SectionLoadingError";
import NoProxy from './NoProxy';

/**
 *  myProxies: pl,
        currentUser: d.hydrateProxyUser(state.domain.cu),
        primaryUser
 * @param {any} props
 */
const ProxyPicker = (props) => {
    const { failure,
        age, primaryUser, myProxies, currentUser, isShowAllUsers,
        history, switchToMyChartUser, hasMychart, proxyListLoaded, savePreferenceCall,
        pickerName, match, patients, resetSeeAllView, serverData, showDependentProxyForm, bffDashboardData } = props;

    const [userSelected, setUserSelected] = useState(null);
    const [userList, setUserList] = useState([]);
    const [links, setLinks] = useState([]);
    const [isAddDependentSkipped, setIsAddDependentSkipped] = useState(false);
    const pn = match && match.params && match.params.pickerName ? match.params.pickerName : "";
    let pickerInfo = usePickerFor(pn,props.isWaiting);
    const onPharmacy = serverData && serverData.bundle && serverData.bundle.toLowerCase() === "pharmacy" ? true : false;

    useEffect(() => {
        setUserList([primaryUser].concat(myProxies));
        let hasProxies = myProxies && myProxies.length > 1 ? true : false;
        let skipPicker = hasProxies ? false : showDependentProxyForm ? false : true;
        const lnks = [];
        //pickerInfo = usePickerFor(pn, props.isWaiting);
        setLinks(lnks);   
      
        if ((hasProxies && isShowAllUsers != null && !isShowAllUsers) || (pickerInfo?.skipPicker !== undefined && pickerInfo?.skipPicker() === true)) {
             skipPicker = true;
         }
        if (onPharmacy || (pickerInfo?.skipPicker !== undefined && pickerInfo?.skipPicker() === false)) {
            skipPicker = false;
        }

        //If we are skipping the proxypicker and a non patient then we will need to switch to the proxy account
        if (skipPicker === true && proxyListLoaded && !bffDashboardData?.data?.myChartStatus?.isPatient) {
            onUserSwitched(patients[1], 2);
        }
         
        logUI("MBHWeb.UI.ProxyPicker", new Date(), Tools.getURLPath());
        if (!hasMychart) {
            props.history.replace("/findcare");
        } else if (skipPicker) {
            props.history.replace({pathname:pickerInfo.toUrl,search:location.search});
        }

    }, []);

    useEffect(() => {
        //if (!props.isWaiting) {
        //    pickerInfo = usePickerFor(pn, props.isWaiting);
        //}
        if (!props.isWaiting && pickerInfo?.skipPicker() === true && props.proxyListLoaded) {// } && !props.bffDashboardData.data.myChartStatus.isPatient) {
            console.info(`>>>ProxyPicker useEffect[props.proxyListLoaded] time to skip`);
            ourCallback();
        }
    }, [props.proxyListLoaded, props.isWaiting]);


    const savePreference = () => {
        // history.block(targetLocation => {
        //     if (isAddDependentSkipped && !actionTaken)
        //         savePreferenceCall();
        //     props.history.push("/");
        //     return true;
        // })
        savePreferenceCall();
    };

    const ourCallback = () => {
        resetSeeAllView();
        const pname = `${pickerInfo.toUrl}${location.search}`;
        history.push({
            pathname: pickerInfo.toUrl,
            search: location.search
        });
    }


    const onUserSelected = (userSelected) => {
        if (userSelected && userSelected.externalId && currentUser && currentUser.externalId &&
            userSelected.externalId === currentUser.externalId) {
            ourCallback();
        }
    };

    const onUserSwitched = (userSelected, index) => {
        //We are push route to my domain before switch mychart user.
        if (onPharmacy) {
            history.push({
                pathname: `${pickerInfo.toUrl}`,
                search: location.search
            });
            switchToMyChartUser(userSelected, index, () => {
                window.userToSwitch = userSelected;
                resetSeeAllView();
            });
        } else {
            console.info(`>>>ProxyPicker onUserSwitched`,userSelected, index);
            switchToMyChartUser(userSelected, index, () => {
                window.userToSwitch = userSelected;
                ourCallback();
            });
        }
    }

    const isProxyAvailable = myProxies && myProxies.length > 1 ? true : false;

    const arePatientsLoaded = patients && patients.length > 0 ? true : false;
    const isAdult = age && age > 17 ? true : false;
    let heading = '';
    if (currentUser && typeof primaryUser.externalId !== 'undefined' &&
        currentUser.externalId !== primaryUser.externalId && currentUser.displayName) {
        heading += ' (' + getFirstName(currentUser.displayName) + ')';
    }

    let body = null;
    body = <LinkText href={pickerInfo.toUrl}> Test</LinkText >;

    if (!proxyListLoaded || (props.isWaiting == undefined || props.isWaiting) || pickerInfo.skipPicker()) {
        body = (<div className="row">
            <div className="col-12 maxWidth-content">
                <Spinner />
            </div>
        </div>);
    } else if (failure) {
        body =
            (<div className="row">
                <div className="col-12 maxWidth-content">
                    <h1 className="page-heading">{heading}</h1>
                    <SectionLoadingError message="We're not able to load the family selection. Please try again later." />
                </div>
            </div>);
    }
    else if (!userSelected) {
        body = <div className="row justify-center">
            {(isProxyAvailable) &&
                <SelectPatient
                    myProxies={myProxies}
                    patients={patients}
                    hasMychart={hasMychart}
                    currentUser={currentUser}
                    primaryUser={primaryUser}
                    switchToMyChartUser={onUserSwitched}
                    isAdult={isAdult}
                    userSelected={userSelected}
                    onUserSelected={onUserSelected}
                    pickerInfo={pickerInfo}
                    className="col-12 maxWidth-content"
                    links={links}
                />
            }
            {(myProxies && myProxies.length === 1) &&

                <>
                <NoProxy myProxies={myProxies} message="Do not ask me this again" pickerInfo={pickerInfo}
                    currentUser={currentUser} patients={patients} savePreference={savePreference} links={links} onActionTaken={ourCallback}
                    />
                </>
            }
        </div>;
    }

    return (
        <>
            {body}
        </>
    );
}

const mapStateToProps = (state) => {
    const pl = [];
    if (state.domain.pl) {
        state.domain.pl.forEach((proxy) => {
            pl.push(d.hydrateProxyUser(proxy));
        });
    }

    return {
        myProxies: pl,
        currentUser: d.hydrateProxyUser(state.domain.cu),
        primaryUser: d.hydrateProxyUser(state.domain.pu),
        isShowAllUsers: state.dashboard.isShowAllUsers,
        failure: state.memberships.proxyListFailure,
        serverData: state.session.serverData,
        technicalHelpDeskNumber: state.session.serverData ? state.session.serverData.technicalHelpDeskNumber : "",
        zipnosis: state.header.zipnosis,
        history: state.session.history,
        isWaiting: state.dashboard?.bffDashboardData?.isWaiting,
        hasMychart: !state.common.epicEHRDown && state.domain.hm,
        proxyListLoaded: state.memberships.proxyListLoaded,
        showDependentProxyForm: state.session.showDependentProxyForm,
        age: state.domain.age,
        showCOVID19Modal: state.session.serverData && state.session.serverData.showCOVID19Modal ? state.session.serverData.showCOVID19Modal : false,
        userName: state.domain.un,
        bffDashboardData: state?.dashboard?.bffDashboardData,
        patients: state.dashboard && state.dashboard.bffDashboardData && state.dashboard.bffDashboardData.data && state.dashboard.bffDashboardData.data.patients ? state.dashboard.bffDashboardData.data.patients : [],
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        switchToMyChartUser: (user, index, callback) => {
            dispatch({ type: types.SWITCH_USER_SAGA, user, index, callback });
        },
        savePreferenceCall: () => {
            dispatch({
                type: types.UPDATE_ADD_DEPENDENT_PROXY_PREFERENCE
            });
        },
        resetSeeAllView: () => dispatch({ type: types.RESET_DASHBOARD_SEE_ALL_VIEW })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProxyPicker));